
    <div class="core"><router-outlet></router-outlet><notifier-container></notifier-container></div>
  


// WEBPACK FOOTER //
// ./src/app/@nucleo/nucleo.component.ts.NucleoComponent.html